import i18next from 'i18next';
import { Backend } from '@karpeleslab/i18next-klb-backend';
import { getLocale } from '@karpeleslab/klbfw';

// Get the current locale from KLB framework
const currentLocale = getLocale();

// Initialize i18next with KLB backend and export the initialization promise
export const i18nextInitialized = i18next
  .use(Backend)
  .init({
    lng: currentLocale, // Use the locale from KLB framework
    fallbackLng: 'en-US',
    load: 'currentOnly',  // only load the specific language requested
    interpolation: {
      escapeValue: false
    },
    debug: process.env.NODE_ENV === 'development'
  });

export default i18next;